import { render, staticRenderFns } from "./base-avatar.vue?vue&type=template&id=30dc3274&scoped=true"
import script from "./base-avatar.vue?vue&type=script&setup=true&lang=js"
export * from "./base-avatar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-avatar.vue?vue&type=style&index=0&id=30dc3274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dc3274",
  null
  
)

export default component.exports